export default "__VITE_ASSET__DkPrGBgA__"